import { MAIN_ACTION } from '../../constants/actions'

const changeMainState = (property, value) => ({
  type: MAIN_ACTION.CHANGE_STATE,
  payload: { property, value }
})

const resetMainState = () => ({
  type: MAIN_ACTION.RESET_STATE
})

const getStakingData = () => ({
  type: MAIN_ACTION.GET_STAKING_DATA
})

const getStakingDataSuccess = (data) => ({
  type: MAIN_ACTION.GET_STAKING_DATA_SUCCESS,
  payload: data
})

const getStakingDataFailed = (error) => ({
  type: MAIN_ACTION.GET_STAKING_DATA_FAILED,
  payload: { error }
})

const claimStaking = () => ({
  type: MAIN_ACTION.CLAIM_STAKING
})

const claimStakingSuccess = (data) => ({
  type: MAIN_ACTION.CLAIM_STAKING_SUCCESS,
  payload: data
})

const claimStakingFailed = (error) => ({
  type: MAIN_ACTION.CLAIM_STAKING_FAILED,
  payload: { error }
})

const claimTap = (type) => ({
  type: MAIN_ACTION.CLAIM_TAP,
  payload: { type }
})

const claimTapSuccess = (data) => ({
  type: MAIN_ACTION.CLAIM_TAP_SUCCESS,
  payload: data
})

const claimTapFailed = (error) => ({
  type: MAIN_ACTION.CLAIM_TAP_FAILED,
  payload: { error }
})

export {
  changeMainState,
  resetMainState,
  getStakingData,
  getStakingDataSuccess,
  getStakingDataFailed,
  claimStaking,
  claimStakingSuccess,
  claimStakingFailed,
  claimTap,
  claimTapSuccess,
  claimTapFailed
}
